import { Injectable } from '@angular/core';
import { CONFIG } from '../../core/config';
import { ViewModel } from '../view-model';
import { Widget } from './widget';

@Injectable({ providedIn: 'root' })
export class DashboardWidget implements ViewModel {
  public readonly friendlyTypeNameSingular: string = 'Dashboard Widget';
  public readonly apiRoute: string = CONFIG.apiRoutes.dashboardWidget;

  public dashboardWidgetId: string;

  public dashboardId: string;

  public widgetId: string;

  public widget: Widget;

  public dashboardPosition: number;

  public title: string;

  public json(): DashboardWidget {
    return this;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public loadFromJson(data: any) {
    this.dashboardWidgetId = data.dashboardWidgetId;
    this.dashboardId = data.dashboardId;
    this.widgetId = data.widgetId;
    this.dashboardPosition = data.dashboardPosition;

    if (data.widget) {
      const widget = new Widget();

      widget.loadFromJson(data.widget);
      this.widget = widget;
    }
  }
}
